import type { SVGProps } from 'react'
const SvgSyTimelapse = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M12 18.7c1.9 0 3.5-.7 4.8-2s2-2.9 2-4.8-.7-3.5-2-4.8-2.9-2-4.8-2v6.7l-4.8 4.8c.7.6 1.4 1.1 2.2 1.4s1.7.5 2.6.5zm0 4.5c-1.6 0-3-.3-4.4-.9S5 20.9 4 19.9s-1.8-2.2-2.4-3.6-.9-2.8-.9-4.4.3-3 .9-4.4S3 4.9 4 3.9s2.2-1.8 3.6-2.4S10.4.6 12 .6s3 .3 4.4.9S19 2.9 20 3.9s1.8 2.2 2.4 3.6.9 2.8.9 4.4-.3 3-.9 4.4-1.4 2.6-2.4 3.6-2.2 1.8-3.6 2.4-2.8.9-4.4.9m0-2.2c2.5 0 4.6-.9 6.4-2.6S21 14.5 21 12s-.9-4.6-2.6-6.4S14.5 3 12 3s-4.6.9-6.4 2.6S3 9.5 3 12s.9 4.6 2.6 6.4S9.5 21 12 21" />
	</svg>
)
export default SvgSyTimelapse
